export const truncateSubtitle = (subtitle: string, wordLimit?: number): string | null => {
  // Get a collection of sentences and their word length //
  let sentences: [string, number][] = subtitle.split('.').map((sentence) => [sentence, sentence.split(' ').length]);
  sentences = sentences.splice(0, sentences.length - 1);
  let slicePoint = 0;
  let wordCount = 0;
  let stop = false;
  const limit = wordLimit ?? 80;
  sentences.forEach((sentence, i) => {
    if (!stop) {
      if (wordCount > limit) {
        stop = true;
        // Are we on the last sentence? //
        if (i === sentences.length - 1) {
          slicePoint = sentences.length;
        } else {
          // Not on the last sentence, cut it at the current sentence //
          slicePoint = i;
        }
      } else {
        slicePoint++;
        wordCount += sentence[1];
      }
    }
  });

  if (slicePoint === sentences.length) {
    return null;
  } else {
    return (
      sentences
        .map((x) => x[0])
        .slice(0, slicePoint)
        .join('. ') + '.'
    );
  }
};
